export const shadows = {
  drawer:
    '-9px 0 28px 0 rgba(0, 0, 0, 0.05), -6px 0 16px -8px rgba(0, 0, 0, 0.08), -12px 0 48px 16px rgba(0, 0, 0, 0.03)',
  popover:
    '0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12)',
  page: '0px 9px 28px 8px rgba(0, 0, 0, 0.025), 0px 6px 16px rgba(0, 0, 0, 0.04), 0px 3px 6px -4px rgba(0, 0, 0, 0.06)',
  focus: '0 0 0px 3px rgba(0,72,220,0.345)',
  focusInset: 'inset 0 0 0px 3px rgba(0,72,220,0.345)',
} as const;
